// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.7578 1.5C13.9723 2.45099 13.5 3.67022 13.5 5C13.5 8.03757 15.9624 10.5 19 10.5C19.9005 10.5 20.7497 10.2821 21.5 9.89844V22.5H2.5V1.5H14.7578ZM7 15V17H14V15H7ZM7 11V13H15V11H7ZM7 7V9H11.5V7H7Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.4551 3.54395L23.6797 5L20.4551 6.45508L19 9.67969L17.5439 6.45508L14.3203 5L17.5439 3.54395L19 0.320312L20.4551 3.54395Z"}}]};

const AiArticleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai-article-filled',
    ref,
    icon: element,
  },
));

AiArticleFilledIcon.displayName = 'AiArticleFilledIcon';

export default AiArticleFilledIcon;
